
// stands for the main media images of the website functionality

import addToCart from '../resources/addToCartLogo.png';
import blueArrow from "../resources/arrow_icon.webp";
import cartLogoTransparent from "../resources/cart_logo_transparent.png";
import cartLogo from "../resources/cart_logo.png";
import cartLogo2 from "../resources/cart_logo2.png";
import clockLogo from "../resources/clockLogo.png";
import def_logo from "../resources/def_img.jpg";
import downArrow from "../resources/downArrow.png";
import emailIcon from "../resources/email_icon.png";
import facebookLogo from "../resources/facebook_transparent_logo.png";
import instagramLogo from '../resources/instagram_logo.png';
import locationLogo from "../resources/locationLogo.png";
import pencil_icon from "../resources/pencil_icon.png";
import trash_icon from "../resources/trash_icon.png";
import main_bg from "../resources/webingo_bg.png";
import webingoLogo from "../resources/Webingo_logo.png";
import whatsappLogo from '../resources/whatsapp_logo.jpg';
import chatbotAvater from "../resources/webingo_chatbot_avatar.png";
import gmailLogo from "../resources/gmail_logo.png";


export const media = {
    addToCart,
    blueArrow,
    cartLogoTransparent,
    cartLogo,
    cartLogo2,
    clockLogo,
    def_logo,
    downArrow,
    emailIcon,
    facebookLogo,
    instagramLogo,
    locationLogo,
    pencil_icon,
    trash_icon,
    main_bg,
    webingoLogo,
    whatsappLogo,
    chatbotAvater,
    gmailLogo,
}
